<template>
    <div class="container">
        <div class="container">
            <div class="top">
                <div class="title">重置密码</div>

                <input class="input_phone" style="margin-top: 18vw;" placeholder="请输入账号绑定的手机号" v-model="phone" type="number" />
                <input class="input_phone" style="margin-top: 10vw;" placeholder="请输入您的验证码" v-model="code" type="number" />
                <div @click="btnSendCode" class="send_code">获取验证码</div>

                <div @click="back" style="width: 16vw; height: 16vw; position: absolute; display: flex; align-items: center; top: 2vw; left: 2vw">
                    <img style="width: 10vw; height: 7.93vw;" src="../assets/back.png" />
                </div>

                <div @click="btnConfirm" class="btn_next">下一步</div>
            </div>

        </div>

    </div>
</template>


<script>
import axios from 'axios';
import ProfitHelper from '../ProfitHelper';
import { prefix, prefix_dev, loginSMS, userVerifyPhoneSMS } from '../url';

export default ({
    data() {
        return {
            urlPrefix: prefix,
            head: {
                version: '',
                edition: '',
                aps: '',
                Authorization: '',
                os: 1,
            },

            phone: '',
            code: '',
            sendTS: 0,
            user_score: 0.00
        };
    },

    created() {
        this.formatUrlParams();
    },

    methods: {
        back() {
            window.location.href = '/profit-account';
        },

        formatUrlParams() {
            if (localStorage.getItem('is_dev') == 'yes') {
                this.urlPrefix = prefix_dev;
            }
            this.head.version = localStorage.getItem('version');
            this.head.edition = localStorage.getItem('edition');
            this.head.aps = localStorage.getItem('aps');
            this.head.Authorization = localStorage.getItem('Authorization');
        },

        btnSendCode() {
            if (this.phone.length != 11) {
                alert('请输入11位手机号码！')
                return;
            }

            const now = new Date().getTime();
            const dur = (now - this.sendTS) / 1000;
            if (dur < 60) {
                const leftSeconds = 60 - parseInt(dur);
                alert(leftSeconds + 's后再试!');
                return;
            }
            this.sendTS = now;

            const url = this.urlPrefix + loginSMS;
            let params = {
                phone: this.phone
            };
            params.sign = ProfitHelper.getPostSign(JSON.stringify(params));
            axios.post(url, params, { headers: this.head }).then(res => {
                const data = res.data.data;
                if (data == true) {
                    alert('验证码发送成功！');
                } else {
                    alert(res.data.msg);
                }
            }) 
        },

        btnConfirm() {
            if (this.code.length == 0) {
                alert('请输入验证码！')
                return;
            }

            const url = this.urlPrefix + userVerifyPhoneSMS;
            let params = {
                phone: this.phone,
                code: this.code
            };
            params.sign = ProfitHelper.getPostSign(JSON.stringify(params));
            axios.post(url, params, { headers: this.head }).then(res => {
                console.log('set password reset si -- -- ------>', res.data);
                const data = res.data.data;
                if (data == true) {
                    window.location.href = '/profit-password';
                } else {
                    alert(res.data.msg);
                }
            })
        }
    }
})
</script>



<style scoped>
.container {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: rgb(255, 255, 255);
}

.top {
    width: 100vw;
    height: 74.6vw;
    display: flex;
    flex-direction: column;
}
.title {
    margin-top: 6vw;
    width: 100%;
    text-align: center;
    font-size: 19px;
    font-weight: 500;
}

.input_p {
    width: 60vw;
    height: 12vw;
    margin-top: 10vw;
    margin-left: 20vw;
    border: 1px #EEE solid;
    border-radius: 12px;
    text-align: center;
    font-size: 24px;
}
.btn_next {
    display: flex;
    width: 88vw;
    height: 12vw;
    background: linear-gradient(to right, #CBACFF, #7384FF);
    align-self: center;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
    color: white;
    border-radius: 28px;
    margin-top: 10vw;
}

.input_phone {
    width: 80vw;
    margin-left: 10vw;
    margin-top: 8vw;
    height: 10vw;
    border: 1px #EEE solid;
    border-top-width: 0px;
    border-right-width: 0px;
    border-left-width: 0px;
    border-bottom-width: 1px;
    font-size: 16px;
}
.send_code {
    width: 24vw;
    height: 8vw;
    border: 1px #EEE solid;
    border-radius: 4vw;
    position: absolute;
    top: 43vw;
    right: 10vw;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 14px;
    display: flex;
    color: #6495ED;
}
</style>